import { COSMOS_URL } from '../../../../globals';

export const GLASS_HEADER_HEIGHT = 72;

// No bricks-next semantic token available — used for nav active state and flyout section titles
export const GLASS_NAV_ACTIVE_COLOR = '#B5CAFF';

export const FULLBLEED_HERO_IMAGE_URL =
  'https://images.opendoor.com/source/s3/imgdrop-production/2026-04-1775664739908-77107_hero-desktop-1728w.jpg?service=cosmos';

// Shared experiment identifier — used across hero, layout, and header gating logic
export const TREATMENT_ANALYTICS_IDS = ['hero-test-vercel', 'fc-address-entry-btf-test'];

export const redirectToLogin = () => {
  if (typeof window !== 'undefined') {
    window.location.href = `${COSMOS_URL}/login?redirectTo=${encodeURIComponent(
      window.location.pathname,
    )}`;
  }
};
